module.exports = __webpack_public_path__ + "img/606-42dfb3.png";